module.exports = __webpack_public_path__ + "img/character_01.b0583c03.svg";